import { useEffect } from "react";

export function Seo({ title, description, path }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }
      meta.content = description;
    }
    // Open Graph
    const setOg = (prop, val) => {
      if (!val) return;
      let el = document.querySelector(`meta[property="${prop}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("property", prop);
        document.head.appendChild(el);
      }
      el.content = val;
    };
    setOg("og:title", title);
    setOg("og:description", description);
    setOg("og:type", "website");
  }, [title, description, path]);
  return null;
}
